import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { LaunchDarklyService } from '../../../../context-discovery-services/services';
import { FeatureFlags } from '../../../../context-discovery-services/constants/feature-flags.const';
import { EventBusService } from '../../../fsl/services/shared/event-bus.service';

@Component({
  selector: 'adminapp-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit, AfterViewInit {
  nav: any;
  coretexNavTabs: any;
  launchDarklySubscription: any;

  constructor(private router: Router, protected ldService: LaunchDarklyService, private eventBusService: EventBusService) {
    this.eventBusService.parentAppNavSelectionRetainSource$.subscribe((id: string) => {
      if (this.nav) {
        this.nav.data = this.nav.data.map((item) => {
          if (item.id === id) {
            item.active = true;
            return Object.assign({}, item);
          }
          return item;
        });
      }
    });

    this.eventBusService.navigationSource$.subscribe((baseHref: string) => {
      if (this.nav) {
        this.makeTabActiveByHref(baseHref);
        this.router.navigate([baseHref]);
      }
    });
  }

  ngOnInit() {
    this.nav = document.getElementById('sideNavBar');
    this.nav.data = [
      {
        'label': 'Upload Site Data',
        'id': 'upload',
        'href': '/upload'
      },
      {
        'label': 'Manage Assets',
        'id': 'identify-assets',
        'href': '/identify-assets'
      },
      {
        'label': 'View Summary',
        'id': 'summary',
        'href': '/summary'
      },
      {
        'label': 'Upload History Data',
        'id': 'upload-history',
        'href': '/upload-history'
      }
    ];
  }

  ngAfterViewInit() {

    setTimeout(function () {
      if (this.nav && this.nav.shadowRoot) {
        this.coretexNavTabs = this.nav.shadowRoot.querySelectorAll('coretex-nav-tab');

        const isHistoryValidationFeatureEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.HISTORY_VALIDATION);
        const isHistoryPublishFeatureEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.PUBLISH_HISTORY_DATA);
        this.addOrRemoveNavData('upload-history', isHistoryValidationFeatureEnabled || isHistoryPublishFeatureEnabled);

        this.launchDarklySubscription = this.ldService.flagChange.subscribe(_ => {
          const isHistoryValidationFeatureEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.HISTORY_VALIDATION, true);
          const isHistoryPublishFeatureEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.PUBLISH_HISTORY_DATA, true);
          this.addOrRemoveNavData('upload-history', isHistoryValidationFeatureEnabled || isHistoryPublishFeatureEnabled);
        });

        this.makeTabActiveByHref(location.pathname);
      }
    }.bind(this));
  }

  addOrRemoveNavData(idToHideOrShow, featureEnabled) {
    const tabToHIdeOrShow = _.find(this.coretexNavTabs, function (tab) { return (tab.data.id === idToHideOrShow); });
    if (tabToHIdeOrShow) {
      tabToHIdeOrShow.style.display = featureEnabled ? 'unset' : 'none';
    }
  }

  makeTabActiveByHref(baseHref) {
    _.each(this.coretexNavTabs, function (tab) {
      tab.active = (tab.data.href === baseHref);

      tab.style.textTransform = 'capitalize';
      tab.style.cursor = 'pointer';
      tab.shadowRoot.querySelector('a').style.width = '100%';
      const divTab = tab.shadowRoot.querySelector('div#tab');
      if (divTab) {
        divTab.style.opacity = 1;
      }
      const tabIcon = tab.shadowRoot.querySelector('coretex-icon');
      if (tabIcon) {
        tabIcon.style.display = 'none';
        tabIcon.style.margin = '0 10px 0 auto';
        tabIcon.style.order = 2;
      }
    });
  }

  onTabClicked(event) {
    const targetHref = event.detail.tab.data.href;
    if (targetHref === location.pathname) {
      this.eventBusService.conveySameAppNavClicked(event.detail.tab.data.id);
    } else {
      this.router.navigate([targetHref]);
    }
  }
}
